let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("378VB")).then(() => parcelRequire('chXTl'));